module.exports = __webpack_public_path__ + "media/customizations/harvestgreen/back-6a6898fae9a571461c420c2680614dd3.jpg";